<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box" style="">
            <h2 class="history_box-head">{{ $t('ContactInfo.ContactInfo') }}</h2>

            <div class="flex_center">
              <el-radio v-model="radio" label="1">{{ $t('ContactInfo.Setascontactperson') }}</el-radio>
              <button class="btn_blue flex_center btn_eee change_btn" v-if="Edit" @click="Edit = !Edit">
                {{ $t('ContactInfo.Edit') }}
              </button>
              <div v-else style="display: flex">
                <button class="btn_blue flex_center change_btn_mr10" @click="ChangeOwnership(1)">
                  {{ $t('MyAccount.Save') }}
                </button>
                <button class="btn_blue flex_center change_btn_gray" @click="CanselList(1)">
                     {{ $t('MyAccount.Cancel') }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit" clearable v-model="Enterprisecertification.firstName" :placeholder="$t('ContactInfo.FirstName')"></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.address1" :placeholder="$t('ContactInfo.AddressLine')"></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.lastName" :placeholder="$t('ContactInfo.LastName')"></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.address2"  :placeholder="$t('ContactInfo.AddressLine')"></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.phoneNumber" :placeholder="$t('ContactInfo.PhoneNumber')"></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.city" :placeholder="$t('ContactInfo.City')"></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.email" :placeholder="$t('ContactInfo.Email')"></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edit"  clearable v-model="Enterprisecertification.zipCode" :placeholder="$t('ContactInfo.ZipCode')"></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-select style="width: 100%; " :disabled="Edit" filterable  v-model="Enterprisecertification.countryCode"   :placeholder="$t('ContactInfo.CountryRegion')" class="fin_top_sel" @change="changeCountry" >
                                        <el-option v-for="item in countryOptions" :key="item.countryCode" :label="item.nameEn" :value="item.countryCode"></el-option>
                                    </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="accountright_cont_box" style="margin-top: 10px">
          <div class="flex_center_between_box" style="">
            <h2 class="history_box-head">{{ $t('ContactInfo.Alternativecontactperson') }}</h2>

            <div class="flex_center">
              <el-radio v-model="radio" label="2">  {{ $t('ContactInfo.Setascontactperson') }}</el-radio>
              <button class="btn_blue flex_center btn_eee change_btn" v-if="Edittwo" @click="Edittwo = !Edittwo">
         {{ $t('ContactInfo.Edit') }}
              </button>
              <div v-else style="display: flex">
                <button class="btn_blue flex_center change_btn_mr10" @click="ChangeOwnership(2)" >
                {{ $t('MyAccount.Save') }}
                </button>
                <button class="btn_blue flex_center change_btn_gray" @click="CanselList(2)">
          {{ $t('MyAccount.Cancel') }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edittwo"  clearable v-model="Peoplecertification.firstName" :placeholder="$t('ContactInfo.FirstName')" ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edittwo"  clearable v-model="Peoplecertification.address1" :placeholder="$t('ContactInfo.AddressLine')" ></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edittwo"  clearable v-model="Peoplecertification.lastName" :placeholder="$t('ContactInfo.LastName')" ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edittwo"  clearable v-model="Peoplecertification.address2" :placeholder="$t('ContactInfo.AddressLine')" ></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" :disabled="Edittwo"  clearable v-model="Peoplecertification.phoneNumber" :placeholder="$t('ContactInfo.PhoneNumber')" ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input"  :disabled="Edittwo" clearable v-model="Peoplecertification.city" :placeholder="$t('ContactInfo.City')" ></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input"  :disabled="Edittwo" clearable v-model="Peoplecertification.email" :placeholder="$t('ContactInfo.Email')" ></el-input>
              </div>
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input"  :disabled="Edittwo" clearable v-model="Peoplecertification.zipCode" :placeholder="$t('ContactInfo.ZipCode')" ></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-select style="width: 100%;"  :disabled="Edittwo" filterable v-model="Peoplecertification.countryCode" :placeholder="$t('ContactInfo.CountryRegion')"  class="fin_top_sel" @change="changeCountry" >
                                        <el-option v-for="item in countryOptions" :key="item.countryCode" :label="item.nameEn" :value="item.countryCode"></el-option>
                                    </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {  setContactPerson,getUserContactPersons, } from "@/api/api.js";
import ReLogin from "../../../components/ReLogin.vue";

export default {
  mixins: [mixins1],
  components: {
    ReLogin
  },
  data() {
    return {
      reLoginVis: false,
      value1: "",
      CategoryVal: "",

      window: window,
      Edit: true,
      Edittwo:true,
      radio: 0,
      countryOptions:[],
      Enterprisecertification: {
        isAlterContactPerson: '',
        isContactPerson:'',
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        city: "",
        zipCode: "",
        address2:'',
      },
      Peoplecertification: {
        isContactPerson:'',
        isAlterContactPerson:'',
        isContact: this.radio2,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        address2:'',
        city: "",
        zipCode: "",
      },
    };
  },
  beforeDestroy() { },
  destroyed() { },
  created(){
    this.getUserContactPersonsList()
  },
  mounted() { 
    this.getCountry();
  },

  methods: {
    CanselList(value){
      if(value==2){
        this.Edittwo = !this.Edittwo
      }else{
        this.Edit = !this.Edit

      }
      this.Peoplecertification={
              isAlterContactPerson:'',
              isContactPerson:'',
        firstName: '',
        lastName: '',
        phoneNumber:'',
        email: '',
        countryCode:'',
        address1: '',
        address2:'',
        city: '',
        zipCode:'',
            }
            this.Enterprisecertification={
              isAlterContactPerson:'',
              isContactPerson:'',
        firstName: '',
        lastName: '',
        phoneNumber:'',
        email: '',
        countryCode:'',
        address1: '',
        address2:'',
        city: '',
        zipCode:'',
        // address2:res.data[0].email,
            }
      this.getUserContactPersonsList()
    },
    getUserContactPersonsList(){
      getUserContactPersons().then(res=>{
        if(res.code==200){
          if(res.data.alt!=null){
            this.Peoplecertification={
              isAlterContactPerson:res.data.alt.isAlter,
              isContactPerson:res.data.alt.isContact,
        firstName: res.data.alt.firstName,
        lastName: res.data.alt.lastName,
        phoneNumber:res.data.alt.phoneNumber,
        email: res.data.alt.email,
        countryCode:res.data.alt.countryRegion,
        address1: res.data.alt.address,
        address2:res.data.alt.address2,
        city: res.data.alt.city,
        zipCode:res.data.alt.zipCode,
            }
           this.radio=res.data.alt.isContact.toString()=='0'?'2':'1'
          }

         if(res.data.con!=null){
          this.Enterprisecertification={
              isAlterContactPerson:res.data.con.isAlter,
              isContactPerson:res.data.con.isContact,
        firstName: res.data.con.firstName,
        lastName: res.data.con.lastName,
        phoneNumber:res.data.con.phoneNumber,
        email: res.data.con.email,
        countryCode:res.data.con.countryRegion,
        address1: res.data.con.address,
        address2:res.data.con.address2,
        city: res.data.con.city,
        zipCode:res.data.con.zipCode,
        // address2:res.data[0].email,
            }
        
            this.radio=res.data.con.isContact.toString()=='0'?'2':'1'
         }
        }
      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      })
    },
          //获取国家
          getCountry() {
            this.countryOptions = JSON.parse(localStorage.getItem('countryList'))[0].countryList;
        },
        changeCountry() {
            this.Peoplecertification.city = '';
            this.Enterprisecertification.city = '';
            this.provinceOptions = [];
            if (this.Peoplecertification.countryCode || this.Enterprisecertification.countryCode) {
            }
        },
    handleSelectionChange() {
      val;
    },
     // 认证
     ChangeOwnership(value){
      let params={
      }
      if(value==1){
        this.Enterprisecertification.isContactPerson=this.radio=='1'?'1':'0'
        this.Enterprisecertification.isAlterContactPerson=0
        params=this.Enterprisecertification
      }else{
        this.Peoplecertification.isContactPerson=this.radio=='2'?'1':'0'
        this.Peoplecertification.isAlterContactPerson=1
   
        params=this.Peoplecertification
      }
   
      setContactPerson(params).then(res=>{
        if(res.code==-1){
          this.$message({
          message: res.msg,
          center: true,
          type: "error",
        });
        
        }else{
          
          if(value==1){
            this.Edit=true
          }
          if(value==2){
            this.Edittwo=true
          }
          this.getUserContactPersonsList()
          this.$message({
          message: res.msg,
          center: true,
          type: "success",

        });
        }
        
      })
    
      
    },
  
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: 'DMSans Bold';
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  border-radius: 0.5714285714285714rem;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}
@media screen and (max-width: 1441px) {

  .btn_blue{
    font-size: 14px;
    /* width: max-content; */
  }
}
.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box {
  margin-right: 1.7857142857142858rem;
  width: 35%;
  height: 2.857142857142857rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.285714285714286rem;
color: #1A2332;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table {
  margin-top: 2.142857142857143rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}


/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

.information-content {
  display: flex;
  margin-bottom: 1.1428571428571428rem;
}

.btn_eee {
  background: #eee;
  color: #1a2332;
}
.el-select-dropdown__item{
  font-size: 1.285714285714286rem !important;
  color: #1A2332;
}
/deep/ .el-radio__label {
  font-size: 1.285714285714286rem;
  color: #1a2332;
}
</style>
